export default __webpack_public_path__ + "static/media/Group9204.d6e2ac8e.svg";